export default __webpack_public_path__ + "static/media/history.ko-4.d00b2c60.png";